import { EventDataSourceImported } from "./data-source-imported";
import { EventDocumentationPublished } from "./documentation-published";
import { EventVersionReleased } from "./version-released";
import { z } from "zod";
export const Event = z.discriminatedUnion("type", [
    EventVersionReleased,
    EventDataSourceImported,
    EventDocumentationPublished,
]);
